import { useTranslation } from 'react-i18next';
import { Language } from '../constants';

export const useTranslatedLanguages = () => {
  const { t } = useTranslation();

  const translatedLanguages: Record<Language, string> = {
    [Language.de]: t('locale.de'),
    [Language.fr]: t('locale.fr'),
    [Language.en]: t('locale.en'),
    [Language.pl]: t('locale.pl'),
  };

  return translatedLanguages;
};
